import React from 'react';
import {
  FDClickableText,
  FDIcon,
  FDStack, FDTitleText,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { RoadmapExplorerGoalFundedProgress } from 'Components/UI/roadmapExplorer/goalsAccordion/goalFundedProgress';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';
import { RoadmapGoalItemDetailsModal } from './RoadmapGoalItemDetailsModal';

export const RoadmapGoalItem = ({ showProgress = false }) => {
  const isMobile = useMobileLayout();
  const parentRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack direction={'column'} paddingX={isMobile ? 2 : 3} paddingY={3} spacing={2} {...dataAttrs('roadmap-goal-item')}>
      <FDStack direction={'row'} spacing={1}>
        <FDIcon icon={resource.attr('icon')} />
        <FDTitleText
          value={<FDClickableText onClick={() => setOpen(true)} label={resource.attr('name')} appearance={'standalone'} />}
          size={'lg'}
          color={'textSecondary'}
        />
      </FDStack>
      <FDStack direction={'column'} spacing={1.5}>
        <div ref={parentRef}>
          <RoadmapExplorerGoalFundedProgress
            resource={resource}
            width={parentRef?.current?.offsetWidth ?? 200}
            progressValue={showProgress ? +resource.attr('progress') : 0}
            progressDescription={showProgress ? resource.attr('progressDescription') : undefined}
            rightAlignedDescription={showProgress ? resource.attr('goalAmount') : resource.attr('overallFundingDescription')}
            tooltipTitle={resource.attr('tooltipTitle')}
            tooltipBody={resource.attr('tooltipBody')}
            hasIcon={!showProgress}
          />
        </div>
      </FDStack>
      <RoadmapGoalItemDetailsModal
        onClose={() => setOpen(false)}
        open={open}
        showProgress={showProgress}
      />
    </FDStack>
  );
};
